import type {VehicleCatalogListResult, VehicleMake, VehicleModel} from "../types";

/** Backend min length for `filter[name]` on vehicle make/model catalog GETs. */
export const VEHICLE_CATALOG_SEARCH_MIN_CHARS = 2;

/** Trailing debounce before catalog make/model name search hits the API. */
export const VEHICLE_CATALOG_SEARCH_DEBOUNCE_MS = 650;

/** Catalog list page size (API max 50). */
export const VEHICLE_CATALOG_PAGE_LIMIT = 50;

/** No active make search — hide stale TanStack Query cache (same as vehicles `q` clear). */
export function vehicleCatalogMakeItems(
  searchText: string,
  queryData: VehicleCatalogListResult<VehicleMake> | undefined,
): VehicleMake[] {
  if (searchText.trim().length < VEHICLE_CATALOG_SEARCH_MIN_CHARS) return [];
  return queryData?.data ?? [];
}

/**
 * Models without make require name search; with make, empty search loads the make's first page.
 * Below min length without make — empty list (no stale results).
 */
export function vehicleCatalogModelItems(
  vehicleMakeId: number | null | undefined,
  searchText: string,
  queryData: VehicleCatalogListResult<VehicleModel> | undefined,
): VehicleModel[] {
  const hasMake =
    vehicleMakeId != null && Number.isFinite(vehicleMakeId) && vehicleMakeId > 0;
  if (!hasMake && searchText.trim().length < VEHICLE_CATALOG_SEARCH_MIN_CHARS) {
    return [];
  }
  return queryData?.data ?? [];
}
